import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { environment } from '../../../../../src/environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlogDetailsPageService {

  private API_URL= environment.API_URL;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  getPostBySlug(slug: string): Observable<any> {
    const url = `${environment.API_URL}/blog-posts?populate=*&filters[slug][$eq]=${slug}`;
    return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
  }

  getRelatedPosts(tags_id: number[], current_post_id: number): Observable<any[]> {
    const url = `${this.API_URL}/blog-posts?populate=*`;
    return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}}).pipe(
      map((res: any) => {
        return res.data.filter((item: any) => {
          const itemTags = item.attributes?.post_tags?.data?.map((tag: any) => tag.id) || [];
          const hasCommonTag = itemTags.some((id: number) => tags_id.includes(id));
          return item.id !== current_post_id && hasCommonTag;
        });
      })
    );
  }
}

